export const AUTH_COOKIE_KEY = 'portaireAuthToken';

export const FILTERING_KEY = 'portairefilters';
